import * as React from "react";
import {
  SecureGateRoute,
  BreadCrumb,
  DetailBotLogModal,
} from "../../components";
import { AppSettings } from "../../configs";
import { ExtendConsiderationPeriodItem } from "../../components/ExtendConsiderationPeriod";
import '../../assets/css/tor-template-list.css'
import ExtendConsiderationPeriodService from '../../services/ExtendConsiderationPeriodService'
import {
  PanelExpand,
  SearchEmployeeModal,
  UploadButton,
  DocumentModal,
  DocumentNotApproveModal,
} from "../../components";
import { msg } from '../../components/Notifications/MsgBox';
import { useHistory, useParams } from "react-router";

const ExtendConsiderationPeriodScreen = () => {

  const history = useHistory();
  const [openLoading,setOpenLoading]= React.useState(false)
  const [attachments,setAttachments]= React.useState([])
  const [messageSearchError,setMessageSearchError]= React.useState('')
  let { extendId, po_contract_no } = useParams();
  const [data, setData]= React.useState({})
  const [logs, setLogs]= React.useState([])
  const [canEdit, setCanEdit]= React.useState(false)
  const [completedDate, setCompletedDate]= React.useState(null)
  const [newConsiderDate, setNewConsiderDate]= React.useState(null)
  

  const handleSearchPoContract = (poNo)=>{
    setOpenLoading(true)
    setMessageSearchError('')
    ExtendConsiderationPeriodService.searchPoContractNo(poNo).then(response=>{

      if(response.success === true)
      {
        setData(response.data.tExtendConsiderationPeriod)
        setCompletedDate(response.data.completed_date)

      }else{
        if(response.message)
        {
          setMessageSearchError(response.message)
          msg.error(response.message)
        }else{
          msg.error('System error.')
        }
      }
      console.log('response', response)
      setOpenLoading(false)
    }).catch(error=>{
      console.log('error', error)
      msg.error(error?.message ?? 'Network error.')
      setOpenLoading(false)
    })
  }

  function ShowsLoading(props) {
      const { isLoading } = props;
      return (
          (isLoading ?
              <div id="loading-element">
                  <div id="loading-indicator">
                      <div className="lds-ripple"><div></div><div></div></div>
                  </div>
              </div>
              : null)
      )
  }

  const handleOnValidate = (action) =>{
    let result = true;
    let messgaes = "";

    console.log('data', data)

    if(!data.consideration_period_new)
    {
      result = false;
      messgaes = messgaes + "กรุณาระบุ จำนวนวันที่ขอขยายเวลาพิจารณา <br />";
    }

    if((data.reason ?? "").trim() === '')
    {
      result = false;
      messgaes = messgaes + "กรุณาระบุ สาเหตุการขอขยายเวลาพิจารณา <br />";
    }

    if(action === 'submit' && attachments.filter(p=> p.isActive === true).length === 0)
    {
      result = false;
      messgaes = messgaes + "กรุณาแนบ เอกสารอ้างอิงคำขอขยายระยะเวลาพิจารณา";
    }

    if(result === false)
    {
      msg.warning(messgaes)
    }

    return result;
  }

  const handleOnSave = () =>{

    if(data.po_header_text)
    {
      if(handleOnValidate("") === true)
      {
        setOpenLoading(true)
        try {
          const obj = {
            extendConsiderationPeriod: data,
            attachents: attachments
          }
          ExtendConsiderationPeriodService.saveExtendConsiderationPeriod(obj).then(response=>{
            console.log('response', response)
            if(response.success)
            {
              msg.success("Save successfully")
              if(data.transaction_no !== extendId)
              {
                history.push(`/ExtendConsiderationPeriodItem/${data.transaction_no}`);
              }else{
                setData(response.data.tExtendConsiderationPeriod)
                setLogs(response.data.logs)
              }
            }else{
              msg.error(response.message)
            }
            setOpenLoading(false)
          }).catch(error=>{
                console.log(error);
                setOpenLoading(false)
                msg.error(error?.message ?? 'Network error.')
          })
        } catch (e) {
            console.log(e);
            setOpenLoading(false)
            msg.error(e?.message ?? 'Network error.')
        }
      }
      
    }
  }

  const handleOnSubmit = () =>{

    if(data.po_header_text)
    {
      if(handleOnValidate("submit") === true)
      {
        msg.showConfirm("ยืนยัน Submit",`ยืนยัน ขยายระยะเวลาพิจารณา PO: ${data.po_contract_no}`,()=>{

          msg.hideConfirm();
          setOpenLoading(true)
        try {
          
          const obj = {
            extendConsiderationPeriod: data,
            attachents: attachments
            }
            ExtendConsiderationPeriodService.submitExtendConsiderationPeriod(obj).then(response=>{
              msg.success("บันทึกข้อมูลสำเร็จ");
              console.log('response', response)
              setCanEdit(false)
              if(response.success)
              {
                history.push(`/ExtendConsiderationPeriodItem/${data.transaction_no}`);

                setData(response.data.tExtendConsiderationPeriod)
                setLogs(response.data.logs)
              }else{
                msg.error(response.message)
              }
              setOpenLoading(false)
            }).catch(error=>{
                  msg.hideConfirm();
                  console.log(error);
                  setOpenLoading(false)
                  msg.error(error?.message ?? 'Network error.')
            })
          } catch (e) {
              msg.hideConfirm();
              console.log(e);
              setOpenLoading(false)
              msg.error(e?.message ?? 'Network error.')
          }
        })
      }
      
    }
  }


  
  
  const onChangeSelectedFile = (file, file_type) => {

  }

  const onUploadComplete = (modalId, obj) => {
  
      try {

        console.log('modalId', modalId, obj)
          setOpenLoading(true)
          ExtendConsiderationPeriodService.getNewAttachments(data.transaction_no).then((response) => {
             
            if(response.success)
            {
              if(response.data.length > 0)
              {
                setAttachments(previous=> ([...previous, ...response.data.map(p=> ({...p, isActive: true}))]))
              }
            }else{
              msg.error(response.message)
            }
            setOpenLoading(false)
          }).catch(error=>{
            console.log(error);
            setOpenLoading(false)
            msg.error(error?.message ?? 'Network error.')
          })
      } catch (e) {
          console.log(e);
          setOpenLoading(false)
          msg.error(e?.message ?? 'Network error.')
      }

  }

  const onUploadCancel =  (modalId) => {    
 
  }

  const handleOnDeleteAttachment = (obj)=>{
    setAttachments(previous=> previous.map(p=> {

      if(p.id === obj.id)
      {
        return {...p, isActive: false}
      }else{
        return p;
      }
    }))
  }

  const handleOnChangeData = (name, value) => {
    console.log('handleOnChangeData', name, value)
    setData(previous=> ({...previous, [name]: value}))

   

    if(name === 'consideration_period_new' && completedDate)
    {
      const newDate = parseInt(value) + parseInt(data.consideration_period_original)

      ExtendConsiderationPeriodService.getNextDayWithoutWeekEndAndHoliday(completedDate, newDate).then(response=> {
        if(response.success === true)
        {
          setNewConsiderDate(response.data)
        }
      })
    }
  }

  React.useEffect(()=>{
    if(extendId !== '0')
    {
      console.log('extendId', extendId)
      ExtendConsiderationPeriodService.getExtendConsiderationPeriod(extendId).then(response=> {
        if(response.success)
        {
          setData(response.data.extendConsiderationPeriod)
          setAttachments(response.data.attachents)
          setLogs(response.data.transactionLogs)
          setCanEdit(response.data.extendConsiderationPeriod.canEdit ?? false)
          setCompletedDate(response.data.completed_date)
          setNewConsiderDate(response.data.newConsiderDate)
        }else{
          msg.error(response.message)
        }
      }).catch(error=>{
          console.log(error);
          setOpenLoading(false)
          msg.error(error?.message ?? 'Network error.')
      })
    }else if(extendId === '0')
    {
      setCanEdit(true)

      if(po_contract_no)
      {
        handleSearchPoContract(po_contract_no)
      }
      
    }
  },[extendId])
  

  return (
    <div className="tor tor-template-list">
      <ShowsLoading isLoading={openLoading} ></ShowsLoading>
      <SecureGateRoute />
      <div id="main-content">
        <div className="page-body">
          <BreadCrumb
            breadcrumb={[
              { name: "RRS Home", url: AppSettings.defaultUrl },
              { name: "ขยายระยะเวลาพิจารณา", url: "/ExtendConsiderationPeriod" },
              { name: "บันทึกขยายระยะเวลาพิจารณา", url: "" },
            ]}
          ></BreadCrumb>

          <div className="sp-page-header-panel row">
            <div className="col-md-5 sp-page-header">
              <h1 className="sp-page-header1">ขยายระยะเวลาพิจารณา</h1>
            </div>
          </div>

          <div className="sp-page-result-container">
            <ExtendConsiderationPeriodItem
              onSearch={handleSearchPoContract}
              messageSearchError={messageSearchError}
              item={data}
              logs={logs}
              attachments={attachments}
              onDeleteAttachment={handleOnDeleteAttachment}
              onChangeItem={handleOnChangeData}
              canEdit={canEdit}
              newConsiderDate={newConsiderDate}
            ></ExtendConsiderationPeriodItem>

          <div className="rrs-detail py-1">
              <div className="row sp-table-content-footer">
                  <div className="col-12 sp-header-button-panel2" style={{justifyContent: 'center',filter: data.po_header_text ? 'unset' : 'grayscale(90%)'}}>
                      { (['', 'DRAFT'].includes(data.status) || extendId === '0') && <a className="sp-btn-icon" onClick={handleOnSave}>
                          <i className="icon btn-order-savedraft" />
                          <span className="sp-btn-icon-label">Save</span>
                      </a>}
                  
                      { (['', 'DRAFT'].includes(data.status) || extendId === '0') && <a className="sp-btn-icon" onClick={handleOnSubmit}>
                        <i className="icon btn-order-publish" />
                        <span className="sp-btn-icon-label3">Submit</span>
                      </a>}
                  </div>
              </div>
          </div>
          </div>
       
        </div>
      </div>
            <DocumentNotApproveModal
                file_category="TE"
                transaction_no={data.transaction_no}
                dataId={data.transaction_no}
                onChangeSelectedFile = {(selectedFile,file_type) => onChangeSelectedFile(selectedFile, file_type)}
                onUploadComplete={onUploadComplete}
                onUploadCancel={(attmentid) => onUploadCancel(attmentid)}
                defaultFileName="เอกสารขยายระยะเวลาพิจารณา"
            ></DocumentNotApproveModal>
    </div>
  );
};

export default ExtendConsiderationPeriodScreen;
